import {
  GET_SEND_PTUK_REQUEST,
  GET_SEND_PTUK_SUCCESS,
  GET_SEND_PTUK_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const sendPtUK = (token, values) => (dispatch) => {
  dispatch({ type: GET_SEND_PTUK_REQUEST });

  return axios({
    method: "POST",
    url: `${BASEURL}create/SendPTUKToBergen`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values
  })
    .then((response) => {
      return dispatch({
        type: GET_SEND_PTUK_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEND_PTUK_ERROR,
        payload: [],
      });
    });
};
